export const SET_CURRENT_LOCAL='SET_CURRENT_LOCAL';
export const SET_DEFAULT_DISTANCE='SET_DEFAULT_DISTANCE';
export const SET_MEASUREMENT_UNIT='SET_MEASUREMENT_UNIT';
export const DEALER_DETAILS_SUCCESS='DEALER_DETAILS_SUCCESS';
export const DEALER_DETAILS_ERROR='DEALER_DETAILS_ERROR';


